import React from 'react';
import style from './style.module.scss';

interface TableHeaderWithSubtitleProps {
    title: string;
    subtitle: string;
}

export const TableHeaderWithSubtitle: React.FC<TableHeaderWithSubtitleProps> = ({
    title,
    subtitle,
}) => (
    <div className={style.container}>
        <div>{title}</div>
        <div className={style.subtitle}>{subtitle}</div>
    </div>
);

export default TableHeaderWithSubtitle;
